import { defineNuxtPlugin, useRouter, useRuntimeConfig } from "#app";
export default defineNuxtPlugin(() => {
  const id = useRuntimeConfig().public.yandexMetrika.id;
  const router = useRouter();
  router.afterEach((to) => {
    window.ym(id, "hit", to.fullPath);
  });
  return {
    provide: {
      metrika: {
        hit: (url, options) => {
          window.ym(id, "hit", url, options);
        },
        reachGoal: (target, params, callback, ctx) => {
          window.ym(id, "reachGoal", target, params, callback, ctx);
        },
        userParams: (params) => {
          window.ym(id, "userParams", params);
        }
      }
    }
  };
});
